"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
// @ts-nocheck
const react_1 = __importStar(require("react"));
const core_1 = require("@material-ui/core");
const TGOptionLazyModalActions = (props) => {
    const { multiSelect, state, isNothingSelected, totalCount, handleClearAll, selectAllAssets } = props;
    const classes = useStyles();
    const numberOfElements = react_1.useMemo(() => {
        if (isNothingSelected) {
            return totalCount;
        }
        return state.length;
    }, [isNothingSelected, totalCount, state]);
    const button = react_1.useMemo(() => {
        if (multiSelect) {
            if (isNothingSelected) {
                return react_1.default.createElement(core_1.Button, { className: classes.btn, onClick: selectAllAssets, variant: 'text' }, "Select All");
            }
            else {
                return react_1.default.createElement(core_1.Button, { className: classes.btn, onClick: handleClearAll, variant: 'text' }, "Deselect All");
            }
        }
        else {
            return react_1.default.createElement(core_1.Button, { className: classes.btn, onClick: handleClearAll, variant: 'text' }, "Clear Selection");
        }
    }, [multiSelect, isNothingSelected, handleClearAll, selectAllAssets]);
    // Brackets are inside spans in order to center them vertically with the text (Roboto by default does not do that)
    if (multiSelect) {
        return (react_1.default.createElement("div", { className: classes.actionsContainer },
            button,
            react_1.default.createElement(core_1.Typography, { className: classes.numberOfElements },
                react_1.default.createElement("span", null, "("),
                numberOfElements,
                react_1.default.createElement("span", null, ")"))));
    }
    return button;
};
const useStyles = core_1.makeStyles(theme => ({
    actionsContainer: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        color: theme.palette.primary.main,
    },
    numberOfElements: {
        fontSize: 16,
        fontWeight: 500,
        fontStyle: 'normal',
        lineHeight: 'normal',
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        color: theme.palette.primary.main,
        marginLeft: 3,
        '& span': {
            height: 21.5,
        },
    },
    btn: {
        padding: 0,
        color: theme.palette.primary.main,
        textTransform: 'none',
        fontSize: 16,
        fontWeight: 500,
        fontStyle: 'normal',
        lineHeight: 'normal',
    }
}));
exports.default = TGOptionLazyModalActions;
//# sourceMappingURL=TGOptionLazyModalActionsWeb.js.map